import { render, staticRenderFns } from "./passagesEvents.vue?vue&type=template&id=09478b92&"
import script from "./passagesEvents.vue?vue&type=script&lang=js&"
export * from "./passagesEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports